<template>
    <a href="#"
        ><i class="mdi mdi-delete"></i></a>
</template>
